'use strict';

/**
 * Copies the coupon code using the Clipboard API.
 */
function copyCoupon(code) {
    if (navigator.clipboard && window.isSecureContext) {
        return navigator.clipboard.writeText(code);
    }

    return Promise.reject(new Error('Clipboard API unavailable'));
}

module.exports = function () {
    var couponCode = new URLSearchParams(window.location.search).get('zcc');

    if (!couponCode) {
        return;
    }

    // Remove coupon code from the URL after reading it.
    var url = new URL(window.location.href);
    url.searchParams.delete('zcc');
    window.history.replaceState({}, document.title, url.toString());

    var $template = $('#couponAlertContent');

    if (!$template.length) {
        return;
    }

    var content = $template.html();

    // Initialize the coupon alert.
    var $alert = $.alert({
        content: content,
        icon: '',
        placement: 'toast',
        theme: 'success',
        dismissible: true,
        autoClose: false,
        containerId: 'couponAlertContainer'
    });

    $alert.on('click', '.js-copy-coupon', function () {
        var $button = $(this);
        var copiedText = $button.data('copiedText') || 'Copied';

        copyCoupon(couponCode)
            .then(function () {
                $button.html(
                    '<svg class="svgicon" aria-hidden="true">' +
                        '<use href="#check_circle"></use>' +
                    '</svg>' +
                    '<span>' + copiedText + '</span>'
                );
            })
            .catch(console.error);
    });
};
